import { Component } from "react";
import { getUser } from "../../actions/auth";
import { hasPermission } from "../../helpers/permissions";

class RoleAwareComponent extends Component {
  shouldBeVisible() {
    const user = getUser();
    if (user) {
      const { authorize, action } = this.props;
      return hasPermission(authorize, action, user);
    }

    return false;
  }
}

export default RoleAwareComponent;
